<template>
  <div class="modal-content">
    <div class="modal-header">
      <button type="button"
              class="close"
              @click="closeModal">
        <span aria-hidden="true">×</span>
        <span class="sr-only">Close</span>
      </button>
      <h4 class="modal-title">Valider le document</h4>
    </div>
    <div class="modal-body">
      <div class="row equal" style="margin-bottom: 20px; min-height: 700px;">
        <div class="col-md-6 col-lg-6">
          <div v-if="model.documentBase64 && model.documentBase64.includes('application/pdf')" style="width: 100%; height: 100%;">
            <object :data="model.documentBase64" style="width: 100%; height: 100%;"></object>
          </div>
          <div v-else-if="model.documentBase64" style="width: 100%; height: 100%;">
            <img :src="model.documentBase64" id="imageM" alt="" style="display: none;">
          </div>
          <h4 v-else>Il faut ajouter le document !</h4>
        </div>
        <div class="col-md-6 col-lg-6">
          <!--"Certificat d'immatriculation"-->
          <div v-if="model.document.code === 'carRegistration'">
            <ul>
              <li>Le document est émis par les autorités françaises</li>
              <li>
                Le titulaire est
                {{ model.dataForValidationPopup.owner.firstName }} {{ model.dataForValidationPopup.owner.lastName }}
              </li>
              <li v-if="model.dataForValidationPopup.coOwner.firstName || model.dataForValidationPopup.coOwner.lastName">
                Le cotitulaire est
                {{ model.dataForValidationPopup.coOwner.firstName }} {{ model.dataForValidationPopup.coOwner.lastName }}
              </li>
              <li>Le véhicule est hors LOA ou leasing</li>
            </ul>
          </div>

          <!--"Contre visite (optionnelle)"-->
          <div v-if="model.document.code === 'consVisit'">
            <ul>
              <li>Il n’y a pas de défaillances critique ou majeure</li>
              <li>Il n’y a pas de défaillance mineure sur le numéro d’identification, le numéro de châssis ou le numéro de série du véhicule</li>
            </ul>
          </div>

          <!--"Controle technique"-->
          <div v-if="model.document.code === 'vehicleInspection'">
            <ul>
              <li>Le contrôle technique date de moins de 6 mois</li>

              <li>
                Les données suivantes sont égales à celles du back-office <br>
                - VIN : {{ model.command.vehicule[0].vehicleIdentification }}<br>
                - Immatriculation : {{ model.command.vehicule[0].licensePlate }}<br>
                - Marque, modèle : {{ model.command.vehicule[0].make }}, {{ model.command.vehicule[0].model }}
              </li>

              <li>Le kilométrage est cohérent avec celui déclaré par le client : {{ model.command.vehicule[0].kilometers }}</li>

              <li>Il n’y a pas de défaillances critique ou majeure</li>

              <li>Il n’y a pas de défaillance mineure sur le numéro d’identification, le numéro de châssis ou le numéro de série du véhicule</li>
            </ul>
          </div>

          <!--"Garantie MAPFRE"-->
          <div v-if="model.document.code === 'warrantyMecanique'">
            <ul>
              <li>
                Le document est une garantie MAPFRE au nom de
                <strong>
                  {{ model.dataForValidationPopup.futureOwner.firstName }} {{ model.dataForValidationPopup.futureOwner.lastName }}
                </strong>
              </li>
            </ul>
          </div>

          <!--"Certificat de situation administrative"-->
          <div v-if="model.document.code === 'nonPedge'">
            <ul>
              <li>
                Le document est bien un certificat de situation administrative. <br>
                Il ne mentionne pas d'objection à la vente.
              </li>
            </ul>
          </div>

          <!--"Copie du chèque de banque"-->
          <div v-if="model.document.code === 'bankCheck'">
            <ul>
              <li>Le document est un chèque de banque</li>
              <li>Le montant du cheque est de {{ model.command.buyerPrice }} euros</li>
              <li>Le cheque est a l'ordre de {{ model.dataForValidationPopup.owner.firstName }} {{ model.dataForValidationPopup.owner.lastName }}</li>
              <li>Le chèque a été controlé auprès de la banque émettrice</li>
            </ul>
          </div>

          <!--"Bon de remise signé"-->
          <div v-if="model.document.code === 'disposal'">
            <ul>
              <li>
                Le document est un bon de remise signé par
                <strong>
                  {{ model.dataForValidationPopup.futureOwner.firstName }} {{ model.dataForValidationPopup.futureOwner.lastName }}
                </strong>
              </li>
            </ul>
          </div>

          <!--"Garantie MAPFRE signée"-->
          <div v-if="model.document.code === 'signedWarrantyMecanique'">
            <ul>
              <li>
                Le document est une garantie MAPFRE signée au nom de
                <strong>
                  {{ model.dataForValidationPopup.futureOwner.firstName }} {{ model.dataForValidationPopup.futureOwner.lastName }}
                </strong>
              </li>
            </ul>
          </div>

          <!--"Identité recto"-->
          <div v-if="model.document.code === 'idCardRecto'">
            <ul>
              <li>
                Le nom du client correspond au nom du client
                <strong v-if="model.document.user === 'owner'">
                  {{ model.dataForValidationPopup.owner.firstName }} {{ model.dataForValidationPopup.owner.lastName }}
                </strong>
                <strong v-if="model.document.user === 'coOwner'">
                  {{ model.dataForValidationPopup.coOwner.firstName }} {{ model.dataForValidationPopup.coOwner.lastName }}
                </strong>
                <strong v-if="model.document.user === 'futureOwner'">
                  {{ model.dataForValidationPopup.futureOwner.firstName }} {{ model.dataForValidationPopup.futureOwner.lastName }}
                </strong>
                <strong v-if="model.document.user === 'seller'">
                  {{ model.dataForValidationPopup.seller.firstname }} {{ model.dataForValidationPopup.seller.lastname }}
                </strong>
                <strong v-if="model.document.user === 'buyer'">
                  {{ model.dataForValidationPopup.buyer.firstname }} {{ model.dataForValidationPopup.buyer.lastname }}
                </strong>
              </li>
            </ul>
          </div>

          <!--"Identité verso"-->
          <div v-if="model.document.code === 'idCardVerso'">
            <ul>
              <li>
                SI LA PERSONNE EST FRANCAISE : <br>
                - Le document est parmi :<br>
                <ul>
                  <li>
                    Carte Nationale d’Identité valide (les CNI sont valides 10 ans, sauf si elles ont été émises à partir du 2 janvier 2004, dans ce cas elles sont valides 15 ans)
                  </li>
                  <li>
                    Passeport valide (les passeports sont valides 10 ans après leur date d’émission) <br>
                  </li>
                </ul>
              </li>
              <li>
                SI LA PERSONNE EST ETRANGERE HORS UE : <br>
                - Le document est parmi : <br>
                <ul>
                  <li>
                    Carte Nationale d’Identité valide émise par un pays de l’Union Européenne (les CNI sont valides 10 ans, sauf si elles ont été émises à partir du 2 janvier 2004, dans ce cas elles sont valides 15 ans)
                  </li>
                  <li>
                    Passeport valide émis par un pays de l’Union Européenne (les passeports sont valides 10 ans après leur date d’émission)
                  </li>
                  <li>
                    Titre de séjour avec une durée minimale de 10 ans émis par les Autorités Françaises <br>
                  </li>
                </ul>
              </li>
              <li>
                SI LA PERSONNE EST ETRANGERE HORS UE : <br>
                - Le document est parmi : <br>
                <ul>
                  <li>
                    Carte d’identité du pays d’origine
                  </li>
                  <li>
                    Passeport du pays d’origine
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <!--"Procuration"-->
          <div v-if="model.document.code === 'procuration'">
            <ul>
              <li>
                Procuration de la part de
                <strong v-if="model.document.user === 'owner'">
                  {{ model.dataForValidationPopup.owner.firstName }} {{ model.dataForValidationPopup.owner.lastName }}
                </strong>
                <strong v-if="model.document.user === 'futureOwner'">
                  {{ model.dataForValidationPopup.futureOwner.firstName }} {{ model.dataForValidationPopup.futureOwner.lastName }}
                </strong>
                <strong v-if="model.document.user === 'coOwner'">
                  {{ model.dataForValidationPopup.coOwner.firstName }} {{ model.dataForValidationPopup.coOwner.lastName }}
                </strong>
              </li>
              <li>
                Pièce d’identité du mandataire associé à la procuration (prénom et nom identiques)
              </li>
              <li>
                Mention du don de pouvoir de vente au mandataire
              </li>
              <li>
                Mention du numéro d’immatriculation du véhicule : {{ model.command.vehicule[0].licensePlate }}
              </li>
              <li>
                Procuration signée avec mention de la date et du lieu
              </li>
            </ul>
          </div>

          <!--"ID de tous les bénéficiaires"-->
          <div v-if="model.document.code === 'beneficiaryId'">
            <ul>
              <li>
                Le document contient les ID recto et verso de tous les bénéficiaires effectifs détenants plus de 25% de la société titulaire du compte de paiement.
              </li>
              <li>
                SI LA PERSONNE EST FRANCAISE : <br>
                - Le document est parmi : <br>
                <ul>
                  <li>
                    Carte Nationale d’Identité valide (les CNI sont valides 10 ans, sauf si elles ont été émises à partir du 2 janvier 2004, dans ce cas elles sont valides 15 ans)
                  </li>
                  <li>
                    Passeport valide (les passeports sont valides 10 ans après leur date d’émission)
                  </li>
                </ul>
              </li>
              <li>
                SI LA PERSONNE EST ETRANGERE HORS UE : <br>
                - Le document est parmi : <br>
                <ul>
                  <li>
                    Carte Nationale d’Identité valide émise par un pays de l’Union Européenne (les CNI sont valides 10 ans, sauf si elles ont été émises à partir du 2 janvier 2004, dans ce cas elles sont valides 15 ans)
                  </li>
                  <li>
                    Passeport valide émis par un pays de l’Union Européenne (les passeports sont valides 10 ans après leur date d’émission)
                  </li>
                  <li>
                    Titre de séjour avec une durée minimale de 10 ans émis par les Autorités Françaises
                  </li>
                </ul>
              </li>
              <li>
                SI LA PERSONNE EST ETRANGERE HORS UE : <br>
                - Le document est parmi : <br>
                <ul>
                  <li>
                    Carte d’identité du pays d’origine
                  </li>
                  <li>
                    Passeport du pays d’origine
                  </li>
                </ul>
              </li>
            </ul>
          </div>

          <!--"KBIS"-->
          <div v-if="model.document.code === 'companyRegistration'">
            <ul>
              <li>Un KBIS de moins de trois mois de la société titulaire du compte de paiement.</li>
            </ul>
          </div>

          <!--"Les status signés de la société"-->
          <div v-if="model.document.code === 'companyStatus'">
            <ul>
              <li>Le document porte un nom de type “statuts de la société”</li>
              <li>Il fait mention des associés de cette société</li>
              <li>Il porte la mention de la composition du capital de la société (sauf si le client a également fourni un document de composition du capital en plus).</li>
            </ul>
          </div>

          <!--"Doc de composition du capital"-->
          <div v-if="model.document.code === 'capitalComposition'">
            <ul>
              <li>
                Le document est parmis : <br>
                <ul>
                  <li>CERFA N°2035-F</li>
                  <li>Liasse fiscale</li>
                  <li>document relatif au bénéficiaire effectif d’une société du Greffe du Tribunal de Commerce</li>
                  <li>Courrier signé du représentant légal de la société</li>
                </ul>
              </li>
            </ul>
          </div>

          <!--"RIB"-->
          <div v-if="model.document.code === 'bankAccountIdentity'">
            <ul>
              <li>
                Le document est un RIB au nom de
                <strong v-if="model.document.user === 'owner'">
                  {{ model.dataForValidationPopup.owner.firstName }} {{ model.dataForValidationPopup.owner.lastName }}
                </strong>
                <strong v-if="model.document.user === 'futureOwner'">
                  {{ model.dataForValidationPopup.futureOwner.firstName }} {{ model.dataForValidationPopup.futureOwner.lastName }}
                </strong>
                <strong v-if="model.document.user === 'buyer'">
                  {{ model.dataForValidationPopup.buyer.firstname }} {{ model.dataForValidationPopup.buyer.lastname }}
                </strong>
              </li>
            </ul>
          </div>

          <!--"IBAN"-->
          <div v-if="model.document.code === 'iban'">
            <ul>
              <li>Le document est un IBAN de la société du compte de paiement</li>
            </ul>
          </div>

          <!--"Justificatif de domicile"-->
          <div v-if="model.document.code === 'proofOfAddress'">
            <ul>
              <li>
                Document au nom de
                <strong v-if="model.document.user === 'owner'">
                  {{ model.dataForValidationPopup.owner.firstName }} {{ model.dataForValidationPopup.owner.lastName }}
                </strong>
                <strong v-if="model.document.user === 'futureOwner'">
                  {{ model.dataForValidationPopup.futureOwner.firstName }} {{ model.dataForValidationPopup.futureOwner.lastName }}
                </strong>
                <strong v-if="model.document.user === 'buyer'">
                  {{ model.dataForValidationPopup.buyer.firstname }} {{ model.dataForValidationPopup.buyer.lastname }}
                </strong>
              </li>
              <li>
                Adresse égale à
                <strong v-if="model.document.user === 'owner'">
                  {{ model.dataForValidationPopup.owner.address.address }}, {{ model.dataForValidationPopup.owner.address.zipCode }}, {{ model.dataForValidationPopup.owner.address.city }}
                </strong>
                <strong v-if="model.document.user === 'futureOwner'">
                  {{ model.dataForValidationPopup.futureOwner.address.address }}, {{ model.dataForValidationPopup.futureOwner.address.zipCode }}, {{ model.dataForValidationPopup.futureOwner.address.city }}
                </strong>
                <strong v-if="model.document.user === 'buyer'">
                  {{ model.dataForValidationPopup.buyer.address.address }}, {{ model.dataForValidationPopup.buyer.address.zipCode }}, {{ model.dataForValidationPopup.buyer.address.city }}
                </strong>
              </li>
              <li>Date au plus tard du {{ currentTimeLess3Months }}</li>
              <li>
                Justificatif de domicile parmi : <br>
                <ul>
                  <li>facture d’électricité, eau, gaz ou téléphone</li>
                  <li>quittance de loyer</li>
                  <li>attestation d’assurance habitation</li>
                  <li>attestation communale délivrée par la mairie </li>
                  <li>favis d’imposition</li>
                </ul>
              </li>
            </ul>
          </div>

          <!--"2ème ID"-->
          <div v-if="model.document.code === 'secondIdRecto' || model.document.code === 'secondIdVerso'">
            <ul>
              <li>
                Pièce d'identité au nom de
                <strong v-if="model.document.user === 'owner'">
                  {{ model.dataForValidationPopup.owner.firstName }} {{ model.dataForValidationPopup.owner.lastName }}
                </strong>
                <strong v-if="model.document.user === 'futureOwner'">
                  {{ model.dataForValidationPopup.futureOwner.firstName }} {{ model.dataForValidationPopup.futureOwner.lastName }}
                </strong>
                <strong v-if="model.document.user === 'buyer'">
                  {{ model.dataForValidationPopup.buyer.firstname }} {{ model.dataForValidationPopup.buyer.lastname }}
                </strong>
                , différente de celle déjà reçue
              </li>
            </ul>
          </div>

          <!--"Titre de séjour"-->
          <div v-if="model.document.code === 'residencePermit'">
            <ul>
              <li>
                SI LA PERSONNE EST ÉTRANGÈRE HORS UE : <br>
                - Le document est émis par les Autorités Françaises <br>
                - Le document est parmi : <br>
                <ul>
                  <li>Titre de séjour avec une durée minimale de 10 ans</li>
                  <li>Carte de résident valable 10 ans</li>
                </ul>
              </li>
            </ul>
          </div>

          <!--"ID supplémentaire"-->
          <div v-if="model.document.code === 'additionalId'">
            <ul>
              <li>
                Le nom du client correspond au nom du client
                <strong>{{ model.dataForValidationPopup.owner.firstName }} {{ model.dataForValidationPopup.owner.lastName }}</strong>
              </li>
              <li>
                Le document d’identité est différent du document d’identité déjà chargé
              </li>
              <li>
                SI LA PERSONNE EST FRANCAISE : <br>
                - Le document est parmi : <br>
                <ul>
                  <li>
                    Carte Nationale d’Identité valide (les CNI sont valides 10 ans, sauf si elles ont été émises à partir du 2 janvier 2004, dans ce cas elles sont valides 15 ans)
                  </li>
                  <li>
                    Passeport valide (les passeports sont valides 10 ans après leur date d’émission)
                  </li>
                </ul>
              </li>
              <li>
                SI LA PERSONNE EST ETRANGERE HORS UE : <br>
                - Le document est parmi : <br>
                <ul>
                  <li>
                    Carte Nationale d’Identité valide émise par un pays de l’Union Européenne (les CNI sont valides 10 ans, sauf si elles ont été émises à partir du 2 janvier 2004, dans ce cas elles sont valides 15 ans)
                  </li>
                  <li>
                    Passeport valide émis par un pays de l’Union Européenne (les passeports sont valides 10 ans après leur date d’émission)
                  </li>
                  <li>
                    Titre de séjour avec une durée minimale de 10 ans émis par les Autorités Françaises
                  </li>
                </ul>
              </li>
              <li>
                SI LA PERSONNE EST ETRANGERE HORS UE : <br>
                - Le document est parmi : <br>
                <ul>
                  <li>
                    Carte d’identité du pays d’origine
                  </li>
                  <li>
                    Passeport du pays d’origine
                  </li>
                </ul>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer justify-content-center">
      <button
        type="button"
        class="btn btn-default"
        @click="closeModal">
        Annuler
      </button>
      <button
        type="button"
        class="btn btn-danger"
        @click="submitValidDocument('non-valid')">
        Non conforme
      </button>
      <button
        type="button"
        class="btn btn-primary"
        @click="submitValidDocument('valid')">
        Conforme
      </button>
    </div>
  </div>
</template>

<script>
  import 'viewerjs/dist/viewer.css'
  import store from '../../config/store'
  import Viewer from 'viewerjs'


  export default {
    data: () => ({
      store
    }),

    computed: {
      model () {
        return store.modal.dataModel
      },
      currentTimeLess3Months () {
          return moment().subtract(3, 'months').format('DD/MM/YYYY');
      },
      image () {
          if(this.model.documentBase64 && !this.model.documentBase64.includes('application/pdf')){
              return this.model.documentBase64
          } else {
              return null
          }
      },
      isImage () {
          if(this.image && typeof this.image === 'string' && this.image.includes('image/')) {
              this.initImageViewer()
              return true
          } else {
              return false
          }
      }
    },

    methods: {
      submitValidDocument(status){
        let valid = ""
        if(status === 'valid'){
            valid = true
        } else {
            valid = false
        }

        this.$bus.$emit('submit-valid-document-' + this.model.document.id.toString(), {'id': this.model.document.id, 'valid': valid })

        this.closeModal()
      },
      initImageViewer () {
          // View an image
          const imageElement = document.getElementById('imageM')
          imageElement.src = this.model.documentBase64

          const viewer = new Viewer(imageElement, {
              inline: true,
              title: false,
              button: false,
              navbar: false,
              toolbar: {
                  zoomOut: { show: 1, size: "large"},
                  zoomIn: { show: 1, size: "large"},
                  oneToOne: 0,
                  reset: { show: 1, size: "large"},
                  prev: 0,
                  play: 0,
                  next: 0,
                  rotateLeft: { show: 1, size: "large"},
                  rotateRight: { show: 1, size: "large"},
                  flipHorizontal: 0,
                  flipVertical: 0,
              },
          });

          viewer.show()
      }
    },

    mounted () {
        if(this.image && typeof this.image === 'string' && this.image.includes('image/')) {
            this.initImageViewer()
        }
    },

  }
</script>

<style>
  .row.equal {
    display: flex;
    flex-wrap: wrap;
  }

  .equal > div[class*='col-'] {
    display: flex;
    flex-direction: column;
  }

  .modal-body li {
    margin-bottom: 15px;
  }

  .modal-body li li{
    margin-bottom: 7px;
  }
</style>
